var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-5"},[_c('h4',{staticClass:"text-capitalize font-weight-bold py-2"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('b-progress',{attrs:{"value":_vm.currentStep,"max":_vm.maxSteps}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }